enum textAlignment {
    Ltr = "ltr",
    Rtl = "rtl",
}

export default textAlignment
